// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__AhUst","header":"ReportDetails_header__2KrpI","title":"ReportDetails_title__3WNlH","left":"ReportDetails_left__3q1X0"};